import React from 'react'
import { useLatest } from 'react-use'
import type { ConfirmDialogOptions } from '@ztechapps/common.hook'
import type { ChatTemplateSelectProps } from './index'
import type { InsertMessageFunction } from '../Chat/Context'
import type { TemplateVariables } from '../Conversation/Context'
import { ChatTemplateSelect } from './index'
import { useTemplateVariables } from '../Conversation/template-helpers/useTemplateVariables'

export type ConversationTemplateSelectProps = {
  insertMessage: InsertMessageFunction
  templateVariables: TemplateVariables
  templateVariableConfirmDialogConfigs?: Record<any, Partial<ConfirmDialogOptions>>
} & ChatTemplateSelectProps

export const ConversationTemplateSelect = ({
  insertMessage,
  templateVariables,
  templateVariableConfirmDialogConfigs,
  ...props
}: ConversationTemplateSelectProps) => {
  const [generate, { generatedValue }] = useTemplateVariables(templateVariables, templateVariableConfirmDialogConfigs)

  // Hosts pass an inline `insertMessage` (a new function every render); the effect must fire on a new
  // `generatedValue` only, never on that identity churn, so it reads the latest one through a ref.
  const insertMessageRef = useLatest(insertMessage)

  React.useEffect(() => {
    if (generatedValue) {
      insertMessageRef.current(generatedValue)
    }
  }, [generatedValue, insertMessageRef])

  const onChange = async (e) => {
    await generate(e?.value)
  }

  return <ChatTemplateSelect {...props} onChange={onChange} />
}
